import { useDeferredValue, useEffect, useMemo, useState } from "react";

export function useCmtsDebouncedSearch(value: string, delayMs = 300): string {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(handle);
  }, [value, delayMs]);
  return useDeferredValue(debounced);
}

export function useCmtsStableQuery<T extends Readonly<Record<string, unknown>>>(query: T): T {
  return useMemo(() => query, [JSON.stringify(query)]);
}
